module.exports = __webpack_public_path__ + "img/order_complete.d33c894.png";